<template>
  <automationList :actions_do_not_affect_system="false"></automationList>
</template>

<script>
export default {
  components: {
    automationList: () => import('./../list/page/View'),
  }
}
</script>
